

const Loader = ({content}) => {
    
    return (
        <div className="loader-container">
            <div>
                <p>{content ? content + "..." : ""}Wait...</p>
                <div className="rotator"></div>
            </div>
        </div>
    )
}

export default Loader;